import { writable } from "svelte/store";

// Used to set the theme of the Global Navigation
export const heroThemeStore = writable("white");
